import {apiHost} from '@libs/providers/api-host.provider';

const url = `${apiHost()}/web/articles`;

export enum HttpStatuses {
    received = 200,
    created = 201,
    notFound = 404,
    unprocessable = 422
}

export function getArticles(compact = false, skip?: number, take?: number, topic?: string, search?: string) {
    const query = new URLSearchParams({});
    if (skip) {
        query.set('skip', String(skip));
    }

    if (take) {
        query.set('take', String(take));
    }

    if (compact) query.set('compact', 'true');

    if (topic) {
        query.set('topic', topic);
    }
    if (search) {
        query.set('search', search);
    }

    return fetch(`${url}?${query}`, {
        method: 'GET',
        headers: {"Content-Type": "application/json"},
    }).then(response => {
        switch (response.status) {
            case HttpStatuses.received:
                return response.json();
            case HttpStatuses.notFound:
                throw new Error('Not found')
            default:
                throw new Error('Smth bad');
        }
    })
}

export function getArticleSlugs() {
    return fetch(`${url}/slugs`, {
        method: "GET",
        headers: {"Content-Type": "application/json"},
    }).then((response) => {
        switch (response.status) {
            case HttpStatuses.received:
                return response.json();
            case HttpStatuses.notFound:
                throw new Error("Not found");
            default:
                throw new Error("Smth bad");
        }
    });
}

export function getPopularArticles(compact = false, take: number = 6,) {
    const query = new URLSearchParams({});
    if (take) {
        query.set('take', String(take));
    }
    if (compact) query.set('compact', 'true');
    return fetch(`${url}/popular?${query}`, {
        method: 'GET',
        headers: {"Content-Type": "application/json"},
    }).then(response => {
        switch (response.status) {
            case HttpStatuses.received:
                return response.json();
            case HttpStatuses.notFound:
                throw new Error('Not found');
            default:
                throw new Error('Smth bad');
        }
    })
}